/*
create-multi-round-tournament.component.ts
Golfhubber
Created by Chetan Baghel on 23/06/2021.
Copyright © 2021 Golfhubber Ltd. All rights reserved.
*/
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FirebaseApp } from 'angularfire2';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import { Attachment } from 'app/models/attachment';
import { Club, Course, Tee } from 'app/models/club';
import { ApiService } from 'app/services/api';
import { ElasticService } from 'app/services/elastic';
import { FormsService } from 'app/services/forms';
import { OAuthService } from 'app/services/o-auth';
import lodash from "lodash";
import * as moment from "moment";
@Component({
  selector: 'app-create-multi-round-tournament',
  templateUrl: './create-multi-round-tournament.component.html',
  styleUrls: ['./create-multi-round-tournament.component.scss']
})
export class CreateMultiRoundTournamentComponent implements OnInit {
  public imageLoader: boolean = true;
  public tournament: any;
  public currentChoosenClub: any = []
  public currentChoosenCourse: any = []
  public currentChoosenTee: any = []
  public currentChoosenHoles: any = []
  public bestOfList = [
    { name: "All", value: "" },
  ]
  public showForm: any;
  public query: Array<string>;
  public clubs: Array<Club>;
  public seachType = "club";
  public typingDelay: any;
  public courses;
  public tees;
  public holesPart;
  public orginalAttachment: Attachment;
  public attachment: Attachment;
  public attachmentExt: string;
  public user: any;
  public minTill: any;
  public minFrom: any;
  public min_no_of_rounds_in_multiround = 2;
  public max_no_of_rounds_in_multiround = 99;
 
  constructor(
    public formsService: FormsService,
    private elasticSearch: ElasticService,
    private router: Router,
    private firebase: FirebaseApp,
    private datePipe: DatePipe,
    private fireAuth: AngularFireAuth,
    private fireDatabase: AngularFireDatabase,
    private apiService: ApiService,
    private oAuthService: OAuthService,
  ) {
    this.user = this.oAuthService.getClub();
    this.query = [];
    this.clubs = [];
    
     this.tournament = {
      name: "",
      multiRoundType: "",
      scoringFormat: 1,
      numberOfRounds: "",
      // bestRoundCount: "", // not using now
      isTourStyle: false,
      description: "",
      image: "",
      originalImage: "",
      userId: this.user.uid,
      uid: this.user.cid,
      tournamentsRound: [],
      team: 0,
      teamPlay: 0,
      maxEntries: "",
      isDeleted: false
     }
  }

  
  ngOnInit() {
    this.minTill = new Date();
    this.minFrom = new Date();
    this.imageLoader = false;
  }
  
  validateNumberOfEntries()
  {
    return parseInt(this.tournament.maxEntries);
  }

  onToggleTourStyleTournament(event: any) {
    this.tournament.numberOfRounds = 4;
    this.initRounds()
  }

  noOfRoundChange($event: any) {
    this.initRounds();
  }

  onMultiroundTypeChange(event: any) {
    if (this.tournament.numberOfRounds != "")
    {
      // this.initRounds(); //old
    }
  }

  onNameChange(event: any) {
     console.log("100",this.tournament)
  }

  track(item:any,index:number){
    return index;
  }
  
  // initRounds1() //old
  // {      
  //   let roundsCount = parseInt(this.tournament.numberOfRounds);
  //   this.tournament.tournamentsRound = []
  //   for (let i = 1; i <= roundsCount; i++)
  //   {
  //     let item = {
  //     cid: "",
  //     eventName: "",
  //     course: "",
  //     tee: "",
  //     holesPart: "",
  //     slop_rating: 113,
  //     handicap_percentage: 100,
  //     startDate: "",
  //     startTime: "",
  //     endDate: `${23}:${59}`,
  //     userId: this.user.uid,
  //     uid: this.user.cid,
  //       }
  //     this.tournament.tournamentsRound.push(item);
  //   }
  // }

  initRounds()
  {
    let roundsCount = parseInt(this.tournament.numberOfRounds);
    if (roundsCount > this.tournament.tournamentsRound.length)
    {
      let currentLength = this.tournament.tournamentsRound.length;
      for (let i = currentLength+1; i <= roundsCount; i++)
      {
        let item = {
        cid: "",
        eventName: "",
        course: "",
        tee: "",
        holesPart: "",
        slop_rating: 113,
        handicap_percentage: 100,
        startDate: "",
        startTime: "",
        endDate: `${23}:${59}`,
        userId: this.user.uid,
        uid: this.user.cid,
          }
        this.tournament.tournamentsRound.push(item);
      }
    }
    console.log( "169",this.tournament.tournamentsRound)
  }

  onRoundClick(event: any) {
    if (this.showForm != event)
    {
      this.showForm = event;
    }
    else this.showForm = -1;
  }
  

  searchMention(i) {
    let queryParams = {};
    
    if (this.query == undefined || this.query.length == 0) {
      queryParams = {
        index: "users",
        type: this.seachType ? this.seachType : "club",
        size: 10,
        "body/query/bool/must/query_string/query": `*`,
        "body/query/bool/must/query_string/fields": ["name"],
      };
    } else {
      queryParams = {
        index: "users",
        type: this.seachType ? this.seachType : "club",
        size: 10,
        "body/query/match_phrase_prefix/name": `${this.query[i]}*`,
      };
    }

    this.elasticSearch
      .search(queryParams)
      .then((result) => {
        this.clubs = [];
        if (result && result["hits"]) {
          lodash.forEach(result["hits"], (item) => {
            console.log(item);
            const club = lodash.assign({ $key: item["_id"] }, item["_source"]);
            this.clubs.push(club);
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
    }
  
  changeQuery(i) {

    clearTimeout(this.typingDelay);
    this.typingDelay = setTimeout(() => {
      this.searchMention(i);
    }, 400);
  }

  onFocus(i) {
    this.searchMention(i);
  }

  onBlur() {
    setTimeout(() => {
      this.clubs = [];
    }, 500);
  }

  chooseClub(club, index) {
    this.tournament.tournamentsRound[index].clubName = club.name;
    this.fireDatabase.object(`/currentVersion/cms_black_theme`).subscribe(result => {
      this.tournament.tournamentsRound[index].CMSVersion = result.$value
    });
    this.tournament.tournamentsRound[index].cid = club.cid ? club.cid : club.$key;
     if (this.tournament.tournamentsRound[index].cid ) {
      let sa = this.tournament.tournamentsRound[index].cid.split("-");
      let s = "";
      sa.map((x) => {
        s = s + x;
      });
       this.tournament.tournamentsRound[index].es_cid = s;
     }
    this.currentChoosenClub[index] = club;
    this.tees = [];
    this.currentChoosenCourse[index] = [];
    this.holesPart = [];
    lodash.forEach(club.courses, (course, key) => {
      this.currentChoosenCourse[index].push(lodash.assign(course, { $key: key }));
    });
    this.query[index] = club.name + " " + "-" + " " + club.address;
    this.clubs = [];
    this.tournament.tournamentsRound[index].course = ""
    this.tournament.tournamentsRound[index].tee = ""
    this.tournament.tournamentsRound[index].holesPart = ""
  }

  onCourseChange(courseId, i) {
    console.log(this.tournament.tournamentsRound[i], this.currentChoosenCourse[i])
    this.tournament.tournamentsRound[i].tee = ""
    this.tournament.tournamentsRound[i].holesPart = ""
    this.currentChoosenTee[i] = []
    let courseHoles;
    let courseName;
    let temp;
    this.currentChoosenCourse[i].forEach(element => {
      if (element.$key === this.tournament.tournamentsRound[i].course)
      {
        temp = element
        courseHoles = element.holes
        courseName = element.name
        this.tournament.tournamentsRound[i].holesCount = element.holes;
      }
    })
    lodash.forEach(temp.tees, (element, key) => {
      Object.assign(element, { $key: key, courseName: courseName, courseHoles: courseHoles})
      this.currentChoosenTee[i].push(element)
    });

    //below code is newly added
     if (this.tournament.tournamentsRound[i].holesCount > 9)
      {
        this.currentChoosenHoles[i] = [
            { value: 0, name: "All 18" },
            { value: 1, name: "Front 9" },
            { value: 2, name: "Back 9" },
          ];
      }
      else {
        this.currentChoosenHoles[i] = [
            { value: 1, name: "All 9" },
          ];
      }
  }

  // onTeeSelect(index: number) {
    // if (this.currentChoosenTee[index].holes > 9)
    // {
    //   this.currentChoosenHoles[index] = [
    //       { value: 0, name: "All 18" },
    //       { value: 1, name: "Front 9" },
    //       { value: 2, name: "Back 9" },
    //     ];
    // }
    // else {
    //   this.currentChoosenHoles[index] = [
    //       { value: 0, name: "All 9" },
    //     ];
    // }
  // }

  deleteRound(index)
  {
    if (!(this.tournament.numberOfRounds > this.min_no_of_rounds_in_multiround))
    {
      alert("Multiround tournament should have atleast 2 rounds");
    }
    else
    {
      this.tournament.tournamentsRound.splice(index, 1);
      this.tournament.numberOfRounds = this.tournament.numberOfRounds - 1;
    }
  }

   changeAttachment(attachment: Attachment): void {
    console.log(attachment.width, attachment.height);

    if (attachment) {
      if (attachment.isOriginal) {
        this.orginalAttachment = attachment;
      } else {
        this.attachment = attachment;
      }
      this.attachmentExt = attachment.file.name.split(".").pop();

    } else {
      this.attachmentExt = "";
    }
   }
  
   private uploadFile(): Promise<any> {
    var newImage = new Promise((resolve, reject) => {
      if (this.attachment) {
        const filename = `${moment().unix()}.${this.attachmentExt}`;
        this.firebase
          .storage()
          .ref(`/tournamets/${this.fireAuth.auth.currentUser.uid}`)
          .child(filename)
          .put(this.attachment.file)
          .then((result) => resolve(result))
          .catch((error) => reject(error));
      } else {
        return resolve(1);
      }
    });
    var OriginalImage = new Promise((resolve, reject) => {
      if (this.attachment) {
        const filename = `${moment().unix()}.${Math.floor(
          Math.random() * 900 + 100
        )}.${this.attachmentExt}`;
        this.firebase
          .storage()
          .ref(`/tournamets/${this.fireAuth.auth.currentUser.uid}`)
          .child(filename)
          .put(this.orginalAttachment.file)
          .then((result) => resolve(result))
          .catch((error) => reject(error));
      } else {
        return resolve(1);
      }
    });
    return Promise.all([newImage, OriginalImage]);
   }
  
  validateWholeForm()
  {
    let isCorrect = true;
    for (let i = 0; i < this.tournament.numberOfRounds; i++)
    {
      lodash.forEach(this.tournament.tournamentsRound[i], (element, key) => {
        
        if (key !== "info" && element === "" || element === undefined )
        {
          if (key === "image" || key === "originalImage" || typeof (element) === "boolean") {
           ;
          }
          else {
            isCorrect = false;
          }
        }
      });

    }
    return isCorrect
  }
  
  submit()
  {
        // this.loading = true;
    let createdAt = new Date().getTime() / 1000;
    let createdBy;
    if (this.user.type == 3) {
      this.tournament.isCreatedFromAdmin = true;
    } else {
      this.tournament.isCreatedFromAdmin = false;
    }
    switch (this.user.type) {
      case 1:
       createdBy = 0;
        break;
      case 2:
        createdBy = 5;
        break;
      case 3:
        createdBy = 1;
        break;
      case 5:
        createdBy = 4;
        break;
      case 6:
        createdBy = 2;
        break;
      case 7:
        createdBy = 3;
        break;
    }
    let data = this.tournament.tournamentsRound[0];
    this.tournament.startDate = "";
    this.tournament.endDate = "";
    this.tournament.multiRoundType = parseInt(this.tournament.multiRoundType);
    this.tournament.numberOfRounds = parseInt(this.tournament.numberOfRounds);
    this.tournament.scoringFormat = parseInt(this.tournament.scoringFormat);
    this.tournament.maxEntries = parseInt(this.tournament.maxEntries);

    
    if(parseInt(this.tournament.multiRoundType) == 0) //for single-course, copy data to all tournaments
    {
      
      for (let i = 1; i < this.tournament.numberOfRounds; i++)
      {
        let temp = {
          CMSVersion: data.CMSVersion,
          cid: data.cid,
          clubName: data.clubName,
          course: data.course,
          es_cid: data.es_cid,
          holesCount: data.holesCount,
          holesPart: data.holesPart,
          tee: data.tee,
          slop_rating: data.slop_rating,
        }
        Object.assign(this.tournament.tournamentsRound[i], temp)
      }
    }
    
    if (!this.validateWholeForm())
    {
      alert("Please Enter all the mandatory fields");
      return
    }
    this.imageLoader = true;
     this.uploadFile()
      .then(async (fileResult) => {
        if (fileResult[0] && fileResult[0].downloadURL) {
          this.tournament.image = fileResult[0].downloadURL;
        }
        if (fileResult[1] && fileResult[1].downloadURL) {
          this.tournament.originalImage = fileResult[1].downloadURL;
        }

        let tournamentIDs = [];
        let updates = {};
         const key1 = this.fireDatabase.database.ref(`/multi-round/`).push()
                .key;
        for (let i = 0; i < this.tournament.numberOfRounds; i++)
        {
          let response: any = await this.apiService
            .object(
              "/courses/" +
              this.tournament.tournamentsRound[i].cid +
              "/" +
              this.tournament.tournamentsRound[i].course +
              "/" +
              this.tournament.tournamentsRound[i].tee
          );
          if (response)
          {
            const key = this.fireDatabase.database.ref(`/tournaments`).push()
              .key;
            tournamentIDs.push(key)

            //startDate, endDate calculation: end

            let val = this.tournament.tournamentsRound[i].startDate
            this.minTill = val
            this.tournament.tournamentsRound[i].startDate = this.datePipe.transform(val, "yyyy-MM-dd")
            const startDate = new Date(this.tournament.tournamentsRound[i].startDate);
            const sdate = moment(startDate).format("YYYY-MM-DD");
            const sdateTime = moment(
              `${sdate} ${this.tournament.tournamentsRound[i].startTime}`,
              "YYYY-MM-DD HH:mm A"
            );
            const edate = moment(startDate).format("YYYY-MM-DD");
            const edateTime = moment(
              `${edate} ${this.tournament.tournamentsRound[i].endDate}`,
              "YYYY-MM-DD HH:mm"
            );
            //startDate, endDate calculation: end

            let tournament = {
              CMSVersion: this.tournament.tournamentsRound[i].CMSVersion,
              cid: this.tournament.tournamentsRound[i].cid,
              clubName: this.tournament.tournamentsRound[i].clubName,
              code: Math.floor(1000 + Math.random() * 9000),
              course: this.tournament.tournamentsRound[i].course,
              createdAt: createdAt,
              createdBy: createdBy,
              endDate: edateTime.unix(),
              startDate: sdateTime.unix(),
              startTime: this.tournament.tournamentsRound[i].startTime,
              slopeRating: parseInt(this.tournament.tournamentsRound[i].slop_rating),
              es_cid: this.tournament.tournamentsRound[i].es_cid,
              eventName: this.tournament.tournamentsRound[i].eventName,
              handicap_percentage: parseInt(this.tournament.tournamentsRound[i].handicap_percentage),
              holesCount: parseInt(this.tournament.tournamentsRound[i].holesCount),
              holesPart: parseInt(this.tournament.tournamentsRound[i].holesPart),
              image: this.tournament.image,
              info: this.tournament.description,
              tee: this.tournament.tournamentsRound[i].tee,
              type: parseInt(this.tournament.scoringFormat),
              team: this.tournament.team,
              teamPlay: parseInt(this.tournament.teamPlay),
              scoreTeamPlay: parseInt(this.tournament.teamPlay),
              //
              noOfEnteries: parseInt(this.tournament.maxEntries),
              isClosed: false,
              isCreatedFromAdmin: this.tournament.isCreatedFromAdmin,
              isDelete: false,
              isFixtureShow: true,
              isLast3ScoreHide: false,
              isShowOnWebsite: true,
              //
              originalImage: this.tournament.originalImage,
              uid: this.tournament.tournamentsRound[i].uid,
              userId: this.tournament.tournamentsRound[i].userId,
              mapWithEvent: 2 ,//
              multiRoundId: key1,
              roundName: "R" + String(i + 1) 
            };
            //multround start date end date calculation tournament: start
            if (!this.tournament.startDate)
            {
              this.tournament.startDate = tournament.startDate
              }
            else if (this.tournament.startDate && tournament.startDate <= this.tournament.startDate)
              this.tournament.startDate = tournament.startDate
            if (!this.tournament.endDate)
            {
              this.tournament.endDate = tournament.endDate
              }
            else if (this.tournament.endDate && tournament.endDate >= this.tournament.endDate)
              this.tournament.endDate = tournament.endDate
            
            updates["/tournaments/" + key] = tournament;
            updates["/tournaments-course/" + key] = response;

            if (!tournament.isClosed) {
              updates[`/server-process/add-tournament/${tournament.cid}/${key}`] = 1;
            }
            updates[
              `tee-slope-ratings/${tournament.cid}/${tournament.course}/${tournament.tee}/verifiedSlopRating`
            ] = +tournament.slopeRating;
            updates[
              `tee-slope-ratings/${tournament.cid}/${tournament.course}/${tournament.tee}/verifiedSlopeRatingDate`
            ] = new Date().getTime() / 1000;
            updates["golf-tournaments/" + this.user.cid + "/" + key] = parseInt(
              new Date(this.minTill).getTime() / 1000 + ""
            );

            if(tournamentIDs.length == parseInt(this.tournament.numberOfRounds)) 
            {
              let temp1 = this.tournament
              temp1.tournamentsRound = tournamentIDs
              updates["/multi-round/" + key1] = temp1;
              return this.apiService.bulkUpdate(updates);
            }
          }

        }
      })
      .then(() => {
        setTimeout(() => {
          return this.router.navigate(["/components/multi-round"]);
        }, 2000);
      })
      .catch((error) => {
        this.error(error);
      });

  }
  
  private error(error): void {
    console.error(error);
    alert("Sorry, something went wrong!");

    // this.loading = false;
  }
  
}

